
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[customPath]",
      function () {
        return require("private-next-pages/[customPath]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[customPath]"])
      });
    }
  